<template>
  <div class="parallax-box-component tva-row">
    <div v-if="device !== 'mobile'" class="box-wrapper tva-col-md-offset-2 tva-col-md-8 tva-col-sm-offset-2 tva-col-sm-8">
      <div
        :class="['box-container ', {'active': active}, {'first': index === 0}, {'second': index === 1}, {'third': index === 2}]"
        :style="{transform: `translateY(${computedOffset * parallax * randomList[index]}px)`}"
        v-for="(element, index) in content"
        :key="index"
      >
        <h3 v-if="element.title" v-html="element.title">{{element.title}}</h3>
        <div class="box">{{element.content}}</div>
        <div class="overline">
          <a :href="element.link" target="_blank">{{element.dida}}</a>
        </div>
        <div class="line"></div>
      </div>
    </div>
    <div v-if="device === 'mobile'" class="box-wrapper tva-col-md-offset-2 tva-col-md-8">
      <div class="box-container" v-for="(element, index) in content" :key="index">
        <h3 v-if="element.title" v-html="element.title">{{element.title}}</h3>
        <div class="box">{{element.content}}</div>
        <div class="overline">
          <a :href="element.link" target="_blank">{{element.dida}}</a>
        </div>
        <div class="line"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["content", "active", "offset"],
  watch: {
    offset(value) {
      if (value !== null) this.computedOffset = value;
    }
  },
  methods: {
    getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }
  },
  data() {
    return {
      computedOffset: null,
      parallax: 400,
      randomList: [0.7, 0.8, 0.4],
      device: ""
    };
  },
  created() {
    this.device = window.innerWidth > 768 ? "desktop" : "mobile";
    window.addEventListener("resize", () => {
      this.device = window.innerWidth > 768 ? "desktop" : "mobile";
    });
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";
.parallax-box-component {
  margin-top: 60px;
  margin-bottom: 200px;
  height: 900px;
  .box-wrapper {
    position: relative;
    height: 100%;
    .box-container {
      position: absolute;
      padding-top: 0px !important;
      padding-left: 0 !important;
      margin-left: 0;
      transition: opacity 0.5s ease;
      width: 30%;
      height: AUTO;
      &.first {
        top: 0;
        left: 0%;
      }
      &.second {
        top: 10% !important;
        left: 70%;
      }
      &.third {
        top: 50%;
        left: 25%;
      }
      h3 {
        text-transform: uppercase;
        line-height: 40px;
        font-size: 30px;
        margin-top: 0;
        margin-bottom: 15px;
        letter-spacing: 1px;
      }
      .box {
        color: $terna-blu;
        font-weight: 400;
      }
      .overline {
        margin-top: 20px;
        a {
          color: black;
        }
      }
      &.active {
        height: 100%;
        .line {
          height: 80px;
        }
      }
      .line {
        height: 10px;
        width: 10px;
        position: absolute;
        top: 10%;
        left: -30px;
        border: solid 2px black;
        transition: height 0.6s ease;
      }
    }
  }
}
@media (max-width: 768px) {
  .parallax-box-component {
    position: relative;
    margin-bottom: 0px;
    margin-top: 30px;
    height: min-content;
    .box-wrapper {
      .box-container {
        position: relative;
        width: 100%;
        margin: 15px 0;
      }
    }
  }
}
</style>
